// WP Accessibility Improvements
// import './vendor/wp/customizer';
import './vendor/wp/navigation';
import './vendor/wp/skip-link-focus-fix';

// JS Components
import './components/animated-svg';
import './components/challenges';
import './components/process-slider';
import './components/siteNav';
import './components/slider';
import './components/servicesGroup';
import './components/video-plyr';

import './pages/home';
import './pages/team';

console.log('main');
